<h4 class="fd-subtitle">Indique o(s) produto(s) e a(s) quantidade(s):</h4>
<form *ngIf="formGroup" [formGroup]="formGroup">
  <div formArrayName="technologyForms">
    <form [formGroupName]="i" *ngFor="let childFormGroup of technologyFormsControls; let i = index">
      <div fxLayout="column" fxLayoutAlign="center stretch">
        <div fxLayoutGap="20px">
          <div [fxFlex]="isCloverKiosk(childFormGroup) ? 50 : 100">
            <fd-select
              (loadItemsFn)="loadTechnologies(i)"
              [parentForm]="childFormGroup"
              (selectionChange)="setPrice(i)"
              [field]="fieldsArray[i].technology"
            >
            </fd-select>
          </div>
          <div *ngIf="isCloverKiosk(childFormGroup)" fxFlex="50">
            <fd-value-editor
              [disabled]="hasSplitTech()"
              (openDialogFn)="openValueEditorModal($event, i)"
              [parentForm]="childFormGroup"
              [field]="fieldsArray[i].price"
              >10</fd-value-editor
            >
          </div>
        </div>

        <fd-clover-kiosk-item-list
          *ngIf="isCloverKiosk(childFormGroup)"
          (itemsUpdated)="onCloverKioskChange($event, i)"
          [serviceContract]="proposal.serviceContract"
          [cloverKioskDraftItems]="cloverKioskDraftItems"
          [maxProductAmount]="MAXIMUM_PRODUCT_AMOUNT"
        ></fd-clover-kiosk-item-list>

        <div *ngIf="!isCloverKiosk(childFormGroup)" fxLayoutGap="20px">
          <div fxFlex="50">
            <fd-select
              (loadItemsFn)="getAmount()"
              [parentForm]="childFormGroup"
              [field]="fieldsArray[i].amount"
              (selectionChange)="getValuesRange($event)"
            >
            </fd-select>
          </div>
          <div fxFlex="50">
            <fd-value-editor
              [disabled]="hasSplitTech()"
              (openDialogFn)="openValueEditorModal($event, i)"
              [parentForm]="childFormGroup"
              [field]="fieldsArray[i].price"
              >10</fd-value-editor
            >
          </div>
        </div>
        <div>
          <fd-button
            size="thin"
            *ngIf="shouldShowRemoveButton(i)"
            fdSecondary
            [content]="removeTechnologyButtonHTML"
            (trigger)="removeTechnologyForm(i)"
          >
          </fd-button>
        </div>
      </div>
    </form>

    <fd-button *ngIf="showAddButtonOrEdi()" size="thin" fdTertiary [content]="addTechnologyButtonHTML" id="btnAdd" (trigger)="addForm()">
    </fd-button>

    <div class="checkbox-container">
      <mat-checkbox
        *ngIf="showAddButtonOrEdi()"
        (change)="onCheckboxChange(ediItem, $event)"
        [value]="ediItem.value"
        [checked]="ediItem.selected"
        class="fd-checkbox"
        [disabled]="false"
        [id]="ediItem.value"
        >{{ ediItem.label }}
      </mat-checkbox>
    </div>

    <div *ngIf="hasCloverTech()">
      <p>
        <i>
          “Ao contratar a tecnologia Clover escolhida, serão habilitados automaticamente para seu cliente o Aplicativo Centraliza, o Serviço
          de Captura e Roteamento, Tap on Phone e, sujeito à aprovação da Fiserv, o serviço de Link de Pagamento. Para estes serviços, não
          haverá cobrança adicional do aluguel da tecnologia Clover acima indicada"
        </i>
      </p>
    </div>

    <div class="checkbox-container">
      <mat-checkbox
        *ngIf="showSplitPaymentCheck()"
        (change)="onCheckboxChangePaymentSplit(paymentSplitItem, $event)"
        [value]="paymentSplitItem.value"
        [checked]="paymentSplitItem.selected"
        class="fd-checkbox"
        [id]="paymentSplitItem.value"
        >{{ paymentSplitItem.label }}
      </mat-checkbox>
    </div>
    <fd-input *ngIf="hasSplitTech()" [parentForm]="formGroup" [field]="fields.ecMasterDocument" (blur)="validateECMaster($event)">
    </fd-input>
  </div>

  <fd-button fdSecondary [content]="'cancelar'" id="btnCancel" (trigger)="back()"> </fd-button>
  <fd-button [content]="'avançar'" id="btnNext" (trigger)="clickBtnNext()"> </fd-button>
</form>
